<!--
 * @Description: lbImage
 * @Author: xiao li
 * @Date: 2021-07-04 00:16:14
 * @LastEditTime: 2024-01-19 14:44:04
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
-->
<template>
  <el-form
    @submit.native.prevent
    :model="info"
    ref="info"
    label-width="150px"
    size="mini"
  >
    <div class="space-sm"></div>
    <el-form-item label="关联用户" prop="user_id">
      {{ info.user_id ? info.nickName : '暂未设置' }}
    </el-form-item>
    <el-form-item
      :label="$t('action.attendantName') + '姓名'"
      prop="coach_name"
    >
      {{ info.coach_name }}
    </el-form-item>
    <el-form-item label="性别" prop="sex">
      {{ ['男', '女'][info.sex] }}
    </el-form-item>
    <el-form-item label="生日" prop="birthday">
      {{ (info.birthday / 1000) | handleTime(1) }}
    </el-form-item>
    <el-form-item label="手机号" prop="mobile">
      {{ info.mobile }}
    </el-form-item>
    <el-form-item label="从业年份" prop="work_time">
      {{ info.work_time > 0 ? `${info.work_time}年` : `暂未设置` }}
    </el-form-item>
    <el-form-item label="意向工作城市" prop="city_id">
      {{ info.city }}
    </el-form-item>
    <el-form-item
      label="所属经纪人"
      prop=""
      v-if="info.partner_id && info.partner_name"
    >
      <div>{{ info.partner_name }}</div>
    </el-form-item>
    <el-form-item
      label="所属代理商"
      prop=""
      v-if="info.admin_id && info.admin_name"
    >
      <div>{{ info.admin_name }}</div>
    </el-form-item>
    <el-form-item
      label="挂靠门店"
      prop="store_id"
      v-if="info.store_id && info.store_name"
    >
      {{ info.store_name }}
    </el-form-item>
    <el-form-item
      label="免出行费半径距离"
      prop="free_fare_distance"
      v-if="free_fare_bear"
    >
      {{
        info.free_fare_distance * 1 > 0
          ? `${info.free_fare_distance}km`
          : `不免出行费`
      }}
    </el-form-item>
    <el-form-item label="所在地址" prop="address">
      {{ info.address || '暂未设置' }}
    </el-form-item>
    <el-form-item label="经度" prop="lng">
      {{ info.lng || '暂未设置' }}
    </el-form-item>
    <el-form-item label="纬度" prop="lat">
      {{ info.lat || '暂未设置' }}
    </el-form-item>
    <div class="space-lg"></div>
    <lb-classify-title
      :title="$t('action.attendantName') + '阶段性分成'"
      :tips="
        '对于新进平台的' +
        $t('action.attendantName') +
        '，且综合素质较好的，可以设置某个阶段固定高提成比例。提成比例和提成限期时间不填写，则默认走统一的浮动比例'
      "
    ></lb-classify-title>
    <el-form-item label="提成比例" prop="balance">
      {{ info.balance ? `${info.balance}%` : `暂未设置` }}
    </el-form-item>
    <el-form-item label="提成限期时间" prop="custom_balance_time">
      <block v-if="info.custom_balance_time.length === 0">暂未设置</block>
      <block v-else>{{ info.custom_balance_time | handleBalanceTime }}</block>
    </el-form-item>
    <div class="space-lg"></div>
    <lb-classify-title title="其他信息"></lb-classify-title>
    <el-form-item :label="$t('action.attendantName') + '简介'" prop="text">
      <div v-html="info.text || '暂未设置'"></div>
    </el-form-item>
    <el-form-item label="身份证号" prop="id_code">
      {{ info.id_code || '暂未设置' }}
    </el-form-item>
    <el-form-item label="身份证照片" prop="id_card">
      <div class="flex-warp mt-sm mb-sm">
        <lb-image
          :src="item.url"
          :isLook="true"
          class="lb-image-item"
          v-for="(item, index) in info.id_card"
          :key="index"
        />
        <block v-if="info.id_card.length == 0">暂未设置</block>
      </div>
    </el-form-item>
    <el-form-item label="资格证书" prop="license">
      <div class="flex-warp mt-sm mb-sm">
        <lb-image
          :src="item.url"
          :isLook="true"
          class="lb-image-item"
          v-for="(item, index) in info.license"
          :key="index"
        />
        <block v-if="info.license.length == 0">暂未设置</block>
      </div>
    </el-form-item>
    <el-form-item label="工作形象照" prop="work_img">
      <div class="flex-warp mt-sm mb-sm">
        <lb-image
          :src="item.url"
          :isLook="true"
          class="lb-image-item"
          v-for="(item, index) in info.work_img"
          :key="index"
        />
      </div>
    </el-form-item>
    <el-form-item label="个人生活照" prop="self_img">
      <div class="flex-warp mt-sm mb-sm">
        <lb-image
          :src="item.url"
          :isLook="true"
          class="lb-image-item"
          v-for="(item, index) in info.self_img"
          :key="index"
        />
        <block v-if="info.self_img.length == 0">暂未设置</block>
      </div>
    </el-form-item>
    <el-form-item label="个人视频介绍" prop="video">
      <video
        controls
        width="500"
        height="300"
        :src="info.video"
        v-if="info.video"
      ></video>
      <block v-if="info.video.length == 0">暂未设置</block>
    </el-form-item>
    <el-form-item label="虚拟订单量" prop="order_num">
      {{ info.order_num }}单（{{
        info.show_salenum ? '不' : ''
      }}显示实际销量和虚拟销量）
    </el-form-item>
    <el-form-item label="是否接单" prop="is_work">
      {{ ['休息', '接单'][info.is_work] }}
    </el-form-item>
    <el-form-item label="选择接单时间" prop="start_time" v-if="info.is_work">
      {{ info.start_time }}
      <block>至{{ info | handleStartEndTime }}</block>
      {{ info.end_time }}
    </el-form-item>
    <el-form-item>
      <div class="space-lg"></div>
      <lb-button @click="$router.back(-1)">{{ $t('action.back') }}</lb-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'lbTechnicianInfo',
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    free_fare_bear: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      routesItem: state => state.routes
    })
  },
  methods: {
  },
  filters: {
    handleTime (val, type) {
      let time = type === 1 ? moment(val * 1000).format('YYYY-MM-DD') : type === 2 ? moment(val * 1000).format('HH:mm:ss') : moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      return time
    },
    handleStartEndTime (val) {
      let text = ''
      let { start_time: start, end_time: end } = val
      let day = moment(Date.now()).format('YYYY-MM-DD')
      if (start && end && (moment(`${day} ${end}`).unix() <= moment(`${day} ${start}`).unix())) {
        text = '次日'
      }
      return text
    },
    handleFileName (url) {
      let text = '暂未设置'
      if (url) {
        text = url.substring(url.lastIndexOf('/') + 1)
      }
      return text
    },
    handleName (id, list) {
      let text = '暂未设置'
      let arr = list.filter(item => {
        return item.id === id
      })
      return arr && arr.length > 0 ? arr[0].title : text
    },
    handleBalanceTime (time) {
      let text = '暂未设置'
      if (time && time.length > 0) {
        text = moment(time[0]).format('YYYY-MM-DD') + ' 至 ' + moment(time[1]).format('YYYY-MM-DD')
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  color: #888;
}
.lb-image-item {
  width: 60px;
  height: 60px;
  margin-left: 10px;
}
.lb-image-item:nth-child(1) {
  margin-left: 0;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/basics/lbTechnicianInfo.vue